<template>
    <div class="">
        <div class="row" role="group">

            <!-- regular radios -->
            <div v-if="!!this.showAs && this.showAs == 'radio'" class="" :class="fieldInnerClass ?? 'col-md-12'">
                <div class="form-check" :class="{ 'mt-3': index != 0 }" v-for="(choice, index) in choices" :key="index">
                    <label class="form-check-label" :key="index" :for="name + index">
                        <input
                            class="form-check-input"
                            type="radio"
                            :value="choice.value"
                            @change.prevent="$emit('inputFromRadio', $event.target.value);"
                            :name="name"
                            :id="name + index"
                        />
<!--                        <span v-html="choice.text"></span>-->
                        <span v-html="this.getTranslatedText(choice.text, 'fields.options')"></span>
                    </label>
                </div>
            </div>

            <!-- as buttons -->
            <div v-else class="btn-group btn-group-lg" :class="fieldInnerClass ?? 'col-md-12'" v-for="(choice, index) in choices" :key="index">
                <label
                class="btn "
                :class="[ {'mt-3': index != 0}, {'active': choice.value == value || (!!this.isMobileDevice && !!this.isHovered) }, choice.btnClass ?? 'btn-outline-'+(this.inputColor.radio ?? 'primary'), {'mobile': !!this.isMobileDevice} ]"
                @mouseenter="this.isHovered = true"
                @mouseleave="this.isHovered = false"
                :key="index"
                >
                    <input
                        type="radio"
                        :value="choice.value"
                        @input.prevent="$emit('inputFromRadioButton', $event.target.value);"
                        :checked="choice.value === value"
                        :name="name"
                        @click.prevent="$emit('inputFromRadioButton', $event.target.value);"
                        style="display:none;"
                    />
<!--                    <span v-html="choice.text"></span>-->
                    <span v-html="this.getTranslatedText(choice.text, 'fields.options')"></span>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import {inject} from "vue";

export default {
    props: ["choices","value","name","label", "fieldInnerClass", "inputColor", "showAs"],
    emits: ["update:model-value","input","input-from-radio","input-from-radio-button","inputFromRadio","inputFromRadioButton","goToNextStep","blur"],
    setup() {
        let isHovered = false;
        let isMobileDevice = ('ontouchstart' in window || navigator.msMaxTouchPoints) ? true : false;
        const { getTranslatedText } = inject('app'); // app is being provided in Application.vue
        return { isMobileDevice, isHovered, getTranslatedText }
    }
}
</script>

<style scoped>
    .btn.mobile, .btn.mobile:hover {
        --bs-btn-color: #0d6efd;
        --bs-btn-bg: transparent;
        --bs-btn-border-color: #0d6efd;

        color: var(--bs-btn-color);
        background-color: var(--bs-btn-bg);
        border-color: var(--bs-btn-border-color);
    }
</style>
